
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsa06f4d3ec3b3f2db21b4d9bf5dfcf51aen from './en.yaml'
            i18n.addResourceBundle('en', 'a06f4d3ec3b3f2db21b4d9bf5dfcf51a', flattenObject(nsa06f4d3ec3b3f2db21b4d9bf5dfcf51aen), true, true);
        
        export default 'a06f4d3ec3b3f2db21b4d9bf5dfcf51a';
    